<script lang="ts">
  import { getContext } from "svelte"
  import Svg from "./Svg.svelte"
  import { default as themeTokens } from "conversion_flows/theme/LibUIThemeTokens"
  import AUText from "component_library/components/svelte/ui/AUText.svelte"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import AUButton from "component_library/components/svelte/ui/AUButton.svelte"
  import AUStack from "component_library/components/svelte/ui/AUStack.svelte"

  const dealerTheme = getContext<DealerTheme>("dealerTheme")
  const tokens = themeTokens(dealerTheme)

  export let svgIcon: string
  export let iconAltText: string
  export let title: string
  export let subtitle: string
  export let clickHandler: (() => void) | undefined = undefined
</script>

<div class="auws-price-alert__view">
  <AUStack gap="xs">
    {#if clickHandler}
      <AUButton
        fullWidth
        color="secondary"
        onClick={clickHandler}
        ariaDescribedby="auws-price-alert-widget-hint"
      >
        <Svg
          alt={iconAltText}
          aria-hidden="true"
          data={svgIcon}
          slot="leftIcon"
        />
        {title}
      </AUButton>
    {:else}
      <div class="auws-price-alert__title" role="heading" aria-level="2">
        <Svg
          width="22px"
          height="22px"
          data={svgIcon}
          color={String(tokens("colors.primary.500"))}
          alt={iconAltText}
        />
        <AUText weight="bold">{title}</AUText>
      </div>
    {/if}
    <AUText
      id={clickHandler ? "auws-price-alert-widget-hint" : undefined}
      role="paragraph"
      weight="medium"
      color="body"
      font="body-small">{subtitle}</AUText
    >
  </AUStack>
</div>

<style>
  .auws-price-alert__view {
    --au-button-secondary-border-color: var(
      --au-button-secondary-hover-border-color
    );
  }

  .auws-price-alert__title {
    display: flex;
    gap: var(--au-spacing-xs);
    justify-content: center;
  }
</style>
